import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const DESIGN_WIDTH = 1100;

// Narrow landscape screens render the game at desktop width and scale it down, so the vendor's
// desktop landscape layout is used instead of its stacked small-screen layout.
function useStageBox() {
    const read = () => {
        const vw = window.innerWidth, vh = window.innerHeight;
        if (vw >= DESIGN_WIDTH || vh > vw) return { width: vw, height: vh, scale: 1 };
        const scale = vw / DESIGN_WIDTH;
        return { width: DESIGN_WIDTH, height: Math.round(vh / scale), scale };
    };
    const [box, setBox] = useState(read);
    useEffect(() => {
        const on = () => setBox(read());
        window.addEventListener('resize', on);
        window.addEventListener('orientationchange', on);
        return () => { window.removeEventListener('resize', on); window.removeEventListener('orientationchange', on); };
    }, []);
    return box;
}

export function Keno4HeartsV2() {
    const box = useStageBox();
    const { user, refreshUser } = useAuth();
    const navigate = useNavigate();
    const frame = useRef(null);
    const timer = useRef(null);
    const onBalance = useCallback(() => {
        clearTimeout(timer.current);
        timer.current = setTimeout(() => refreshUser?.(), 400);
    }, [refreshUser]);
    useEffect(() => {
        function receive(e) {
            if (e.origin !== window.location.origin || e.source !== frame.current?.contentWindow) return;
            if (e.data?.type === 'k4h:exit') navigate('/casino/slots');
            if (e.data?.type === 'k4h:balance') onBalance();
        }
        window.addEventListener('message', receive);
        return () => window.removeEventListener('message', receive);
    }, [navigate, onBalance]);
    if (!user) return <p data-testid="k4h-v2-signin">Please sign in to play 4 Hearts Keno.</p>;
    return (
        <iframe
            key={String(user.id)} ref={frame} data-testid="k4h-v2-frame"
            src="/games/4-hearts-keno/index.html" title="4 Hearts Keno" allow="autoplay; fullscreen" allowFullScreen
            style={{ position: 'fixed', top: 0, left: 0, width: box.width, height: box.height, border: 0, background: '#050d19',
                zIndex: 60, transform: box.scale === 1 ? 'none' : `scale(${box.scale})`, transformOrigin: 'top left' }}
        />
    );
}

export default function Keno4HeartsRoute() {
    const { loading } = useAuth();
    if (loading) return <div data-testid="k4h-v2-loading" style={{ position: 'fixed', inset: 0, background: '#050d19' }} />;
    return <Keno4HeartsV2 />;
}
